/**
客户服务 文章
**/
<template>
  <div style="width: 100%; margin: auto">
   <div class="topBg" v-if="showindex !=3">
      <img src="../../assets/images/pc/aboutBg2.jpg" class="">
      <!-- <span>久久为功，稳步推进</span> -->
    </div>
    <div class="topBgBox" v-if="showindex ==3">
      <img src="../../assets/images/pc/aboutBg1.png" class="topBgTop">
     <img src="../../assets/images/pc/helpTitle.png" class="hdImg">
    </div>
    <div class="titleText" v-if="showindex != 3">
      诺安应急消防科技有限公司以消防连锁、科技研发、电子商务、教育培训为核心业务，涉足金融投资、文化传媒、公益宣传等领域，多元化经营的现代大型企业，“诺安应急消防”作为公司倾力打造的知名品牌已经享誉行业内外。
公司秉承“让更多的人懂得避险自救、让更多的人能够避险自救”的企业使命，以诺安消防报、救命网、新媒体、公益大篷车:连锁终端、双创园产业基地等为依托为大众保驾护航。投巨资打造的诺安公益宣讲大篷车，不忘初心、牢记使命、奔走在神州大地，行程40余万公里，普惠大众260余万人，持续践行一个有担当企业的社会责任。
公司树立了“正知、正念、正能量:崇尚创新、追求卓越”的企业价值观；确立了“以人为本、德才兼备”的企业人才观，营造企业快乐工作氛围，强化人才培养与储备。
依托电子商务铺设30+300+3000家品牌连锁终端，建设国内安全产业、创业创新、软性综合服务平台:“科海.众创汇”双创园，整合行业资源打造全国消防产业集群基地，将诺安建设成为应急消防领域全产业链公司。
    </div>
    <el-row style="margin: 0 auto 0;width: 1200px;" :gutter="60">
      <!-- <el-col :span="17" class="rightaside"> -->
      <router-view @changeActive="changeIndex"></router-view>
      <!-- </el-col> -->
    </el-row>
  </div>

</template>
<script>
  import {
    article_category_list,
    helpArticle_list
  } from '@/api/xunyou'
  import hotArticle from '@/components/hotArticle'
  export default {
    data() {
      return {
        articleList: [],
        navTitle: '热门文章',
        isShowHot: false,
        defalut: [this.$route.fullPath],
        defaultActive: this.$route.fullPath,
        leftMenu: [
          // {
          //     id:1,
          //     menu:'站点帮助',
          //     url:'/siteHelp?articleId=1',
          //     sub_menu:[
          //         {
          //             id:1,
          //             title:'帮助中心',
          //             url:'/siteHelp?articleId=2',
          //         },
          //         {
          //             id:2,
          //             title:'店主之家',
          //             url:'/siteHelp?articleId=3',
          //         },
          //         {
          //             id:3,
          //             title:'支付方式',
          //             url:'/siteHelp?articleId=4',
          //         },
          //         {
          //             id:4,
          //             title:'售后服务',
          //             url:'/siteHelp?articleId=5',
          //         },
          //         {
          //             id:5,
          //             title:'客服中心',
          //             url:'/siteHelp?articleId=6',
          //         },{
          //             id:6,
          //             title:'关于我们',
          //             url:'/siteHelp?articleId=7',
          //         },{
          //             id:7,
          //             title:'商家入驻',
          //             url:'/siteHelp?articleId=8',
          //             sub_menu:[
          //                 {
          //                     id:1,
          //                     title:'入驻流程',
          //                     url:'/siteHelp?articleId=9',
          //                 }
          //             ]
          //         },
          //     ]
          // },
        ],
        showindex:0
      };
    },
    // 注册组件
    components: {
      hotArticle
    },
    /**
     * 数据发生改变
     */

    //   watch:{

    //     $route(n,o){
    //         if(n.fullPath.indexOf('itemId')>0){ //监听路由参数是否变化
    //         console.log(n.fullPath,'路径上水水水水')
    //         this.isShowHot = !this.isShowHot
    //         }
    //     }

    // },

    /**
     * 创建完毕
     */
    created() {
      console.log(this);
    },
    mounted() {
      if (this.$route.fullPath.indexOf('categoryId') > 0) {
        this.defaultActive = this.$route.fullPath
        this.defalut[0] = this.$route.fullPath
      };
      //   if(this.$route.fullPath.indexOf('itemId')>0){
      //       this.isShowHot = !this.isShowHot
      //   };
      // this.getArticleList()
      this.getHelpArticle_list()
      //   console.log(this.$route,this.$route.fullPath,'路劲发')
    },

    watch: {
      '$route'(to, from) { //监听路由是否变化
        if (to.query.categoryId != from.query.categoryId) { //判断categoryId是否有值
          //调数据
          if (this.$route.fullPath.indexOf('categoryId') > 0) {
            this.defaultActive = this.$route.fullPath
            this.defalut[0] = this.$route.fullPath
          };
        }
      }
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      changeIndex(val){
          this.showindex=val
      },
      // 文章分类列表
      getArticleList() {
        article_category_list()
          .then(res => {
            if (res.code == 0) {
              console.log(res)
              this.leftMenu = res.data;
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('获取文章分类列表失败，请稍后再试！')
          })
      },
      // 文章（和公告）列表接口
      getHelpArticle_list() {
        helpArticle_list({
            articleIsPopular: 1 // 热门文章查询
          })
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.articleList = res.rows.slice(0, 5);
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            // this.loading = false
            this.$message.error('获取文章列表失败，请稍后再试！')
          })
      },
    },
  };
</script>

<style scoped lang="less">
  .breakcrumbHeader {
    margin: 15px 0;
  }

  .topBg {
    width: 100%;
    height: auto;
    position: relative;
    text-align: center;
    margin-bottom:120px;
    img {
      width: 100%;
      height: 100%;
    }

    span {
      font-size: 36px;
      color: #fff;
      font-weight: 900;
      position: absolute;
      top: 45%;
      left: 0;
      right: 0;
      z-index: 0;
    }
  }
  .topBgBox{
    position: relative;
    width: 100%;
    // min-height: 414px;
    position: relative;
    text-align: center;
    .topBgTop {
      width: 100%;
      height: 100%;
    }
    .hdImg{
      position: absolute;
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
      width: 156.01px;
      height: 109.1px;
      border:1px dashed #fff;
    }
  }

  .titleText {
    width: 1200px;
    padding: 27px 26px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(120, 130, 140, 0.12);
    border-radius: 4px;
    margin: 0 auto;
    margin-top: -170px;
    position: absolute;
    left: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/serviceArticle/index.vue